import { render, staticRenderFns } from "./IconCategory.vue?vue&type=template&id=fd836d98"
import script from "./IconCategory.vue?vue&type=script&lang=js"
export * from "./IconCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports